/**
 * Bulk-create — weight / dimension unit PARSING.
 *
 * Reads the unit out of a spreadsheet column. It does not convert: bulk-create
 * sends each row in its own units and the server converts, once. The two
 * converters that used to live here were unreachable and are deleted.
 */
import type { DimensionUnit, WeightUnit } from "./types";

/** Normalise a spreadsheet's weight-unit cell to a WeightUnit. */
export const parseWeightUnit = (unit: string): WeightUnit => {
  const normalized = unit.toLowerCase().trim();
  if (
    normalized === "lb" ||
    normalized === "lbs" ||
    normalized === "pound" ||
    normalized === "pounds"
  )
    return "lb";
  if (normalized === "oz" || normalized === "ounce" || normalized === "ounces")
    return "oz";
  if (normalized === "g" || normalized === "gram" || normalized === "grams")
    return "g";
  return "kg"; // default
};

/** Normalize a free-text dimension unit (e.g. "inches") to a DimensionUnit. */
export const parseDimensionUnit = (unit: string): DimensionUnit => {
  const normalized = unit.toLowerCase().trim();
  if (normalized === "in" || normalized === "inch" || normalized === "inches")
    return "in";
  return "cm"; // default
};
